import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "account__left-wrapper" }
const _hoisted_2 = { class: "account__left" }
const _hoisted_3 = {
  key: 0,
  class: "account__left-list"
}
const _hoisted_4 = { class: "account__left-item-wrapper" }
const _hoisted_5 = { class: "account__left-item clip-anim account__left-profile" }
const _hoisted_6 = { class: "account__left-item-wrapper" }
const _hoisted_7 = { class: "account__left-item" }
const _hoisted_8 = { class: "account__left-item-wrapper" }
const _hoisted_9 = { class: "account__left-item" }
const _hoisted_10 = { class: "account__left-item-wrapper" }
const _hoisted_11 = { class: "account__left-item" }
const _hoisted_12 = { class: "account__left-item-wrapper" }
const _hoisted_13 = { class: "account__left-item" }
const _hoisted_14 = { class: "account__left-item-wrapper" }
const _hoisted_15 = { class: "account__left-item" }
const _hoisted_16 = { class: "account__left-item-wrapper" }
const _hoisted_17 = { class: "account__left-item" }
const _hoisted_18 = {
  key: 0,
  class: "account__left-words"
}
const _hoisted_19 = { key: 1 }
const _hoisted_20 = {
  key: 1,
  class: "account__left-item clip-anim account__left-profile"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Profile = _resolveComponent("Profile")!
  const _component_ThemeSwitcher = _resolveComponent("ThemeSwitcher")!
  const _component_scanner_words = _resolveComponent("scanner-words")!
  const _component_CreateFolder = _resolveComponent("CreateFolder")!
  const _component_ExportWords = _resolveComponent("ExportWords")!
  const _component_ImportWords = _resolveComponent("ImportWords")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_ctx.isMyUser)
        ? (_openBlock(), _createElementBlock("ul", _hoisted_3, [
            _createElementVNode("li", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createVNode(_component_Profile, { profile: _ctx.profile }, null, 8, ["profile"])
              ])
            ]),
            _createElementVNode("li", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("h3", null, _toDisplayString(_ctx.Ti18N("account.toggle")), 1),
                _createVNode(_component_ThemeSwitcher)
              ])
            ]),
            _createElementVNode("li", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _createVNode(_component_scanner_words)
              ])
            ]),
            _createElementVNode("li", _hoisted_10, [
              _createElementVNode("div", _hoisted_11, [
                _createVNode(_component_CreateFolder)
              ])
            ]),
            _createElementVNode("li", _hoisted_12, [
              _createElementVNode("div", _hoisted_13, [
                _createVNode(_component_ExportWords)
              ])
            ]),
            _createElementVNode("li", _hoisted_14, [
              _createElementVNode("div", _hoisted_15, [
                _createVNode(_component_ImportWords)
              ])
            ]),
            _createElementVNode("li", _hoisted_16, [
              _createElementVNode("div", _hoisted_17, [
                (_ctx.wordsLength > 0)
                  ? (_openBlock(), _createElementBlock("h3", _hoisted_18, _toDisplayString(_ctx.Ti18N("account.allWords")) + ": " + _toDisplayString(_ctx.wordsLength), 1))
                  : (_openBlock(), _createElementBlock("h3", _hoisted_19, _toDisplayString(_ctx.Ti18N("account.allWords")) + ": 0", 1))
              ])
            ])
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_20, [
            _createVNode(_component_Profile, { profile: _ctx.profile }, null, 8, ["profile"])
          ]))
    ])
  ]))
}